import * as React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { ErrorMessage } from 'ui/shared/messages';
import { DeviceStatus } from 'ui/shared/deviceStatus';
import { DeviceEvent } from 'shared/models';
import { Dictionary, values } from 'lodash';

type ItemParams = {
    event: DeviceEvent;
    displayName: string;
};

const EventListItem = ({ event, displayName }: ItemParams) => {
    const { deviceId, status, created } = event;
    const when = moment(created);
    const now = moment();
    const old = when.diff(now, 'months') >= 11;
    return (
        <tr>
            <td>{ displayName || deviceId }</td>
            <td><DeviceStatus status={ status } showLabel={ true }/></td>
            <td>{ when.format(old ? 'll' : 'MMM D') }</td>
            <td>{ when.format('LT') }</td>
        </tr>
    );
};

const NoEvents = () => {
    const { t } = useTranslation();
    return (
        <tr>
            <td colSpan={ 4 } style={ { opacity: .5 } }>{ t('BUILDING.DEVICES.NO_EVENTS') }</td>
        </tr>
    );
};


export type Params = {
    events: Dictionary<DeviceEvent> | null;
    deviceNameById: (id: string) => string;
    onClickShowMore: () => void;
    hasMore?: boolean;
    errorMessage?: string | null;
};

export const EventList = ({ events, deviceNameById, onClickShowMore, hasMore = false, errorMessage = '' }: Params) => {
    const { t } = useTranslation();
    return (
        <table className="ui single line compact table" style={ { width: '720px' } }>
            <colgroup>
                <col style={ { width: '40%' } }/>
                <col style={ { width: '25%' } }/>
                <col style={ { width: '18%' } }/>
                <col style={ { width: '17%' } }/>
            </colgroup>
            <thead>
                <tr>
                    <th>{ t('DEVICES.COLUMN.NAME') }</th>
                    <th>{ t('DEVICES.COLUMN.STATUS') }</th>
                    <th>{ t('DEVICES.COLUMN.DATE') }</th>
                    <th>{ t('DEVICES.COLUMN.TIME') }</th>
                </tr>
            </thead>
            <tbody>
                {events && values(events).sort((a, b) => b.id - a.id).map(event =>
                    <EventListItem
                        key={ event.id }
                        event={ event }
                        displayName={ deviceNameById(event.deviceId) }
                    />
                )}
                { (!events || !Object.keys(events).length) && <NoEvents/> }
                { hasMore &&
                    <tr>
                        <td colSpan={ 4 } style={ { textAlign: 'center' } }>
                            <button className="ui basic button" onClick={ onClickShowMore }>{ t('COMMAND.SHOW_MORE') }</button>
                        </td>
                    </tr>
                }
                { errorMessage &&
                    <tr>
                        <td colSpan={ 4 }>
                            <ErrorMessage message={ errorMessage }/>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    );
};
